import { Pipe, PipeTransform } from "@angular/core";

/**
 * Generic pipe to search by "code" property
 */
@Pipe({
    name: "searchByCode",
    standalone: false
})
export class SearchByCodePipe implements PipeTransform {
  transform(listGeneric: Array<any>, ...args: any[]): Array<any> {
    let filterPredicate: string = args[0] as string;

    if (filterPredicate.length > 2) {
      listGeneric = listGeneric.filter((entry: any) =>
        entry.code.includes(filterPredicate)
      );
    }

    return listGeneric;
  }
}
